import React, { useEffect, useState } from 'react';
import { SchoolOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';

import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';
import { useSelector, useDispatch } from 'react-redux';
import { useError } from 'services/ErrorContext';
import { solicitudFormularios } from 'services/servicioPost';
import { alturaContainer, anchoMaxForms } from 'utils/constants';
import { datosFormDatosPersonales, tooltips, datosFechaNac, datosFormContactoExt } from 'utils/formData';
import {
  IFormato,
  IFormDatosContactoExt,
  IFormExtendido,
  IFormDatosPersonales,
  IFormTaller,
  ISelectOptions,
  IFormulario,
  IEmail,
} from 'utils/models/interfaces';
import { fetchGrillaTalleres } from 'utils/redux/features/talleresGrillaSlice';
import { fetchTallerPorId } from 'utils/redux/features/tallerIdSlice';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import { formatoFechaYYYYMMDD, crearOpcionesTipos } from 'utils/utilities';
import Formulario from '../Formulario/Formulario';
import { useParams } from 'react-router-dom';
import PageContainer from 'components/PageContainer/PageContainer';

const InscripcionTaller = () => {
  const { talleresGrilla, loadingTalleresGrilla, errorTalleresGrilla } = useSelector(
    (state: RootState) => state.talleresGrilla
  );
  const { error, setError, clearError, loading, setLoading } = useError();
  const { id } = useParams();
  const { taller, loadingTaller, errorTaller } = useSelector((state: RootState) => state.taller);

  const [mensajeExito, setMensajeExito] = useState('');
  const dispatch = useDispatch<AppDispatch>();
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario = usuarioJSON && JSON.parse(usuarioJSON);
  const fechaNacimiento = usuario?.FechaNac && new Date(usuario?.FechaNac);

  const datosNombreApellido = datosFormDatosPersonales.filter(
    dato => dato.name === 'nombre' || dato.name === 'apellido'
  );

  const datosFormContactoLogueado: IFormato<IFormDatosContactoExt>[] = [
    {
      name: 'Telefono',
      label: 'Teléfono',
      inputType: 'tel',
      halfWidth: 'left',
      pattern: tooltips.telefono.pattern,
      tooltip: tooltips.telefono.tooltip,
      adornment: 'tel',
      defaultValue: usuario?.Telefono,
      subtituloSeccion: 'Ingresá los datos para que podamos contactarnos contigo',
    },
    {
      name: 'Email',
      label: 'Email',
      required: false,
      inputType: 'email',
      adornment: 'email',
      pattern: tooltips.email.pattern,
      tooltip: tooltips.email.tooltip,
      halfWidth: 'right',
      defaultValue: usuario?.Email,
    },
  ];

  const datosFechaNacLogueado: IFormato<Omit<IFormExtendido, keyof IFormDatosPersonales>>[] = [
    {
      name: 'fechaNac',
      label: 'Fecha de nacimiento',
      inputType: 'date',
      defaultValue: fechaNacimiento ? formatoFechaYYYYMMDD(fechaNacimiento) : undefined,
    },
  ];

  // Lista de datos solamente de taller
  const datosFormTaller: IFormato<Omit<IFormTaller, keyof IFormExtendido>>[] = [
    {
      name: 'taller',
      label: 'Taller',
      inputType: 'select',
      subtituloSeccion: 'Taller de interés',
      defaultValue: taller.Id,
      disabled: true,
    },
    { name: 'experiencia', label: '¿Tenés experiencia?', halfWidth: 'left', inputType: 'checkbox', required: false },
  ];

  const camposTaller: IFormato<IFormTaller>[] = usuario
    ? [...datosFormContactoLogueado, ...datosFechaNacLogueado, ...datosFormTaller]
    : [...datosNombreApellido, ...datosFechaNac, ...datosFormContactoExt, ...datosFormTaller];

  useEffect(() => {
    id && dispatch(fetchTallerPorId(Number(id)));
    dispatch(fetchGrillaTalleres());
  }, [id, dispatch]);

  const opcionesTalleres: ISelectOptions[] = crearOpcionesTipos(talleresGrilla, 'taller');

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    const nombreTaller = taller.Nombre;
    const nombre = data.nombre || usuario?.Nombre;
    const apellido = data.apellido || usuario?.Apellido;
    const email = data.Email || usuario?.Emai;
    const telefono = data.Telefono || usuario?.Telefono;

    const request: IEmail = {
      Subject: 'Teatro Bosch Web - Nueva solicitud de inscripción a taller',
      Body: `
          Nombre: ${nombre} <br>
          Apellido: ${apellido}<br>
          Email: ${email ? email : 'No ingresado'} <br>
          Teléfono: ${telefono}<br>
          Experiencia: ${data.experiencia ? 'Sí' : 'No'}
        `,
      Title: `Taller: ${nombreTaller}`,
    };

    try {
      if (!nombre || !apellido || !telefono) {
        setError('Error en alguno de los datos');
        throw new Error('Error en alguno de los datos');
      }
      await solicitudFormularios('taller', request, setError, setLoading);
      setMensajeExito(
        `¡Gracias por tu solicitud de inscripción a ${taller.Nombre}! Nos pondremos en contacto contigo.`
      );
    } catch (err) {
    }
  }

  const handleVolver = () => {
    setMensajeExito('');
  };

  return (
    <PageContainer marginBottom={true}>
      {loadingTalleresGrilla || loadingTaller ? (
        <Spinner />
      ) : (
        <Box minHeight={alturaContainer} maxWidth={anchoMaxForms} mx="auto">
          {errorTalleresGrilla || errorTaller ? (
            <NoResponse />
          ) : (
            <Formulario
              campos={camposTaller}
              titulo={`Inscripción a ${taller.Nombre}`}
              mensaje="Motivo por el que me interesa inscribirme"
              datos={opcionesTalleres}
              onSubmit={handleSubmit}
              onVolver={handleVolver}
              mensajeExito={mensajeExito}
              mensajeError={error}
              loading={loading}
              iconoBoton={SchoolOutlined}
              anchoMax={700}
              textoBoton="Suscribirme"
            />
          )}
        </Box>
      )}
    </PageContainer>
  );
};

export default InscripcionTaller;
